module.exports = __webpack_public_path__ + "static/img/Jack-Ziebell.45f2b43.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jack-Ziebell.jpg
// module id = AQeS
// module chunks = 0